import { render } from "./NewModalOrderConfirm.vue?vue&type=template&id=59398145&scoped=true"
import script from "./NewModalOrderConfirm.vue?vue&type=script&lang=js"
export * from "./NewModalOrderConfirm.vue?vue&type=script&lang=js"

import "./NewModalOrderConfirm.vue?vue&type=style&index=0&id=59398145&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59398145"]])

export default __exports__